import nodeDescriptions from './nodeDescriptions';
import nodeStates from './nodeStates';

export default [
    {
        nodeTypes: [nodeDescriptions.creation],
        state: nodeStates.completedBag,
        translationKey: 'bagTagNumberCreated',
    },

    {
        nodeTypes: [nodeDescriptions.activation],
        state: nodeStates.future,
        translationKey: 'expectedActivationDetails',
    },

    {
        nodeTypes: [nodeDescriptions.activation],
        state: nodeStates.missed,
        translationKey: 'noActivationDetails',
    },

    {
        nodeTypes: [nodeDescriptions.activation],
        state: nodeStates.completedBag,
        translationKey: 'actualActivation',
    },

    {
        nodeTypes: [nodeDescriptions.load],
        state: nodeStates.completedBag,
        translationKey: 'loadDetails',
    },

    {
        nodeTypes: [nodeDescriptions.load],
        state: nodeStates.missed,
        translationKey: 'noLoadScanDetails',
    },

    {
        nodeTypes: [nodeDescriptions.load],
        state: nodeStates.future,
        translationKey: 'expectedLoadScanDetails',
    },

    {
        nodeTypes: [nodeDescriptions.offload],
        state: nodeStates.completedBag,
        translationKey: 'offloadDetails',
    },

    {
        nodeTypes: [nodeDescriptions.unload],
        state: nodeStates.completedBag,
        translationKey: 'unloadDetails',
    },

    {
        nodeTypes: [nodeDescriptions.uldPositioning],
        state: nodeStates.completedBag,
        translationKey: 'uldPositionedDetails',
    },

    {
        nodeTypes: [nodeDescriptions.departure],
        state: nodeStates.completedFlight,
        translationKey: 'flightDepartedDetails',
    },

    {
        nodeTypes: [nodeDescriptions.departure],
        state: nodeStates.future,
        translationKey: 'flightToDepartDetails',
    },
    {
        nodeTypes: [nodeDescriptions.arrival],
        state: nodeStates.completedFlight,
        translationKey: 'flightArrivedDetails',
    },

    {
        nodeTypes: [nodeDescriptions.arrival],
        state: nodeStates.future,
        translationKey: 'flightToArriveDetails',
    },

    {
        nodeTypes: [nodeDescriptions.arrival],
        state: nodeStates.completedFlight,
        translationKey: 'flightArrived',
    },

    {
        nodeTypes: [nodeDescriptions.arrival],
        state: nodeStates.future,
        translationKey: 'flightToArrive',
    },

    {
        nodeTypes: [nodeDescriptions.delivery],
        state: nodeStates.completedBag,
        translationKey: 'bagDelivered',
    },

    {
        nodeTypes: [nodeDescriptions.reflight],
        state: nodeStates.completedReflight,
        translationKey: 'reflightDetails',
    },
];
